import apiClient from './api';

export interface NotificationTypes {
  order_updates: boolean;
  payment_reminders: boolean;
  promotional: boolean;
}

export interface NotificationPreferences {
  email_enabled: boolean;
  sms_enabled: boolean;
  whatsapp_enabled: boolean;
  notification_types: NotificationTypes;
}

export interface NotificationPreferencesUpdate {
  email_enabled?: boolean;
  sms_enabled?: boolean;
  whatsapp_enabled?: boolean;
  notification_types?: NotificationTypes;
}

export interface TestNotificationRequest {
  notification_type: 'email' | 'sms' | 'whatsapp';
}

export interface TestNotificationResponse {
  success: boolean;
  message: string;
  details?: any;
}

// Customer Notification Services
export const updateCustomerNotifications = async (
  customerId: string,
  preferences: NotificationPreferencesUpdate
): Promise<any> => {
  const response = await apiClient.patch(
    `/customers/${customerId}/notifications`,
    preferences
  );
  return response.data;
};

export const sendCustomerTestNotification = async (
  customerId: string,
  type: 'email' | 'sms' | 'whatsapp'
): Promise<TestNotificationResponse> => {
  const response = await apiClient.post(
    `/customers/${customerId}/notifications/test`,
    { notification_type: type }
  );
  return response.data;
};

// Supplier Notification Services
export const updateSupplierNotifications = async (
  supplierId: string,
  preferences: NotificationPreferencesUpdate
): Promise<any> => {
  const response = await apiClient.patch(
    `/suppliers/${supplierId}/notifications`,
    preferences
  );
  return response.data;
};

export const sendSupplierTestNotification = async (
  supplierId: string,
  type: 'email' | 'sms' | 'whatsapp'
): Promise<TestNotificationResponse> => {
  const response = await apiClient.post(
    `/suppliers/${supplierId}/notifications/test`,
    { notification_type: type }
  );
  return response.data;
};
